import { ResourcesTab } from '../../components/organisms/navigation/ResourcesTab'
import useUserPermission from '../useUserPermission'

const useStatisticsRoute = () => {
  const { canSeeStatistics } = useUserPermission('menu')

  return [{ path: '/estadisticas', component: ResourcesTab, hasPermission: canSeeStatistics }]
}
export default useStatisticsRoute
